import { memo } from 'react';
import { Button, Fade, VStack } from '@chakra-ui/react';

import { usePageScrollLock } from 'shared/hooks';
import ButtonGoTo from 'shared/ButtonGoTo';
import InterText from 'shared/InterText';

import { headerNavButtonsData } from 'constants/header';
import { HEADER_BREAKPOINT, HEADER_HEIGHTS } from 'constants/global';

const HeaderMobileMenu = ({ isMenuOpen, toggleIsMenuOpen }) => {
  usePageScrollLock(isMenuOpen);

  return (
    <Fade
      id="mobile-header-menu"
      in={isMenuOpen}
      unmountOnExit
      transition={{
        enter: { duration: 0.3, ease: 'linear' },
        exit: { duration: 0.3, ease: 'linear' },
      }}
      style={{ position: 'fixed', top: 0, left: 0, zIndex: '1000' }}
    >
      <VStack
        w="100dvw"
        h="100dvh"
        bgColor="ourBlack"
        pt={HEADER_HEIGHTS}
        hideFrom={HEADER_BREAKPOINT}
      >
        <VStack
          boxSize="full"
          justify="space-between"
          p="24px 16px 40px"
          gap="40px"
          overflow="auto"
        >
          <VStack as="nav" aria-label="Мобильная навигация" w="full" gap="12px">
            {headerNavButtonsData.map(({ text, onItemClick }, i) => (
              <Button
                key={i}
                w="full"
                h="unset"
                p="16px"
                bg="deepBlue"
                borderRadius="12px"
                justifyContent="start"
                color="ourWhite"
                _hover="unset"
                _active="unset"
                onClick={() => {
                  onItemClick();
                  toggleIsMenuOpen();
                }}
              >
                <InterText textStyle="b3" fontSize="18px">
                  {text}
                </InterText>
              </Button>
            ))}
          </VStack>

          <ButtonGoTo p="16px 40px" onBtnClick={toggleIsMenuOpen} />
        </VStack>
      </VStack>
    </Fade>
  );
};

export default memo(HeaderMobileMenu);
